import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  NgbAlertModule,
  NgbNavModule,
  NgbTooltipModule,
  NgbDatepickerModule,
  NgbTimepickerModule,
  NgbTypeaheadModule,
  NgbDropdownModule,
  NgbModalModule,
  NgbPopoverModule,
  NgbAccordionModule
} from "@ng-bootstrap/ng-bootstrap";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    NgbAlertModule,
    NgbNavModule,
    NgbTooltipModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    NgbTypeaheadModule,
    NgbDropdownModule,
    NgbModalModule,
    NgbPopoverModule,
    NgbAccordionModule
  ],
  exports: [
    NgbAlertModule,
    NgbNavModule,
    NgbTooltipModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    NgbTypeaheadModule,
    NgbDropdownModule,
    NgbModalModule,
    NgbPopoverModule,
    NgbAccordionModule
  ]
})
export class BootstrapModule { }
